var map = {
	"./check.png": "722d",
	"./logo.png": "9d64",
	"./logo2.png": "dd88",
	"./logo3.png": "bdf3",
	"./logo4.png": "cc7c",
	"./m.png": "accc",
	"./no_image.jpg": "083f",
	"./patrn.jpg": "43ad",
	"./user.jpg": "3810"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";